/* eslint-disable no-console */
// config
import { ENV, LOCAL } from 'config';

class LoggerService {
  public loggerEnabled = ENV !== 'PROD' || LOCAL;

  public error = (...message: unknown[]) => {
    if (this.loggerEnabled) {
      console.error(...message);
    }
  };

  public log = (module: LogModules, ...message: unknown[]) => {
    if (this.loggerEnabled) {
      console.log(`>>> ${module}:`, ...message);
    }
  };
}

export default new LoggerService();
